export const NUMBER = 426;
export const NAME = `goto \"bad\" does not match any card IDs (check your spelling)`;
export const DESCRIPTION = ``;

export const INVALID = [
`_roleplay_

**goto bad**`,
];

export const VALID = [
`_roleplay_ (#target)

Text

**goto target**`,
];
